'use client';

import { c as _c } from "react/compiler-runtime";
import { Spinner } from '@common/components';
import { useBodyScrollLock } from '@common/hooks';
import { useIsGuest } from '@/hooks/useIsGuest';
import { useAdpopcornSspFullscreenAd } from '@/modules/adpopcorn-ssp';
import { ADPOPCORN_SSP_MODULE } from '@/modules/wello-app';
import { openResponsiveDialog } from '@/stores/ResponsiveDialogStore';
import { LuckyLottoCard } from '../../_components/LuckyLottoCard';
import { useAdpopcornSspPlacementId } from '../../_hooks/useAdpopcornSspPlacementId';
import { useBenefitGate } from '../../_hooks/useBenefitGate';
import { AD_TRIGGER_PENDING_NOTICE } from '../../_utils/adTriggerNotice';
import { useDrawLottoOutcome } from '../_hooks/useDrawLottoOutcome';
import { LotteryResultContent } from './LotteryResultContent';
import { LuckyTicketCard } from './LuckyTicketCard';
interface LotteryTicketBoardProps {
  isGuest: boolean;
}

//* 응모 탭→광고 등장→결과 도착까지를 전체 블로킹으로 잇는다 — 작은 텍스트 버튼의 회색 전환만으론
//* 수 초짜리 광고 준비를 버티는 피드백이 안 돼 이탈로 이어진다. 결과 다이얼로그(backdrop z-40)보다 아래.
const LottoEntryPreparingOverlay = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div role="status" className="fixed inset-0 z-30 flex flex-col items-center justify-center gap-16 bg-Gray-black/60"><Spinner aria-hidden={true} color="white" /><p className="font-600 text-Gray-white typo-body4">{AD_TRIGGER_PENDING_NOTICE}</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export const LotteryTicketBoard = t0 => {
  const $ = _c(20);
  const {
    isGuest: serverIsGuest
  } = t0;
  const isGuest = useIsGuest(serverIsGuest);
  const {
    triggerGate,
    gateModals
  } = useBenefitGate();
  const {
    drawLotto,
    isDrawing
  } = useDrawLottoOutcome();
  const placementId = useAdpopcornSspPlacementId(ADPOPCORN_SSP_MODULE.REWARD_VIDEO);
  let t1;
  if ($[0] !== drawLotto || $[1] !== placementId) {
    t1 = {
      autoShow: true,
      onCompleted: () => {
        drawLotto(placementId, _temp);
      }
    };
    $[0] = drawLotto;
    $[1] = placementId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    load,
    phase
  } = useAdpopcornSspFullscreenAd(ADPOPCORN_SSP_MODULE.REWARD_VIDEO, t1);
  const isPreparingEntry = phase === "pending" || isDrawing;
  useBodyScrollLock(isPreparingEntry);
  let t2;
  if ($[3] !== load || $[4] !== placementId || $[5] !== triggerGate) {
    t2 = () => {
      triggerGate(["app", "login", "adult", "consent"], () => {
        load(placementId);
      });
    };
    $[3] = load;
    $[4] = placementId;
    $[5] = triggerGate;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleApply = t2;
  let t3;
  if ($[7] !== handleApply || $[8] !== isGuest || $[9] !== phase) {
    t3 = <LuckyLottoCard isGuest={isGuest} onApply={handleApply} adTriggerPhase={phase} />;
    $[7] = handleApply;
    $[8] = isGuest;
    $[9] = phase;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== isGuest) {
    t4 = <LuckyTicketCard isGuest={isGuest} />;
    $[11] = isGuest;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== isPreparingEntry) {
    t5 = isPreparingEntry ? <LottoEntryPreparingOverlay /> : null;
    $[13] = isPreparingEntry;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== gateModals || $[16] !== t3 || $[17] !== t4 || $[18] !== t5) {
    t6 = <div className="flex flex-col gap-16 p-20 xl:px-0 xl:py-20">{t3}{t4}{t5}{gateModals}</div>;
    $[15] = gateModals;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
};
function _temp(t0) {
  const {
    variant,
    wonPoint
  } = t0;
  openResponsiveDialog({
    component: LotteryResultContent,
    ariaLabel: "\uC751\uBAA8 \uACB0\uACFC",
    drawerType: "bottom",
    props: {
      variant,
      wonPoint
    }
  });
}